MOVE.MultilineEllipsis = (function(MOVE) {
  "use strict";

  $.fn.multilineEllipsis = function() {
    return this.each(function() {

      var el = $(this);
      $(el).css({
        'display': 'block',
        'overflow': 'hidden',
        'white-space': 'normal'
      });

      var text = el.html();
      var t = $(this.cloneNode(true)).hide().css({
        'position':'absolute',
        'overflow':'visible'
      }).width(el.width()).height('auto');

      el.after(t);
      var height = function() {
        return t.height()-1 > el.height();
      };

      while (text.length > 0 && height()) {
        text = text.substr(0, text.length - 1);
        t.html(text + "...");
      }

      el.html(t.html());
      t.remove();
    });
  };

  var init = function(selector) {

    $(selector).multilineEllipsis();

  }; // /init closing brackets

  MOVE.MultilineEllipsis = {
    init: init
  };

  return MOVE.MultilineEllipsis;

})(MOVE || {});



// WEBPACK FOOTER //
// ./shared_non_critical/multiline-ellipsis.js